import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';

//Api
import relacaoResiduoVolumetria_api from '../../../api/relacaoResiduoVolumetria_api';
import residuo_api from '../../../api/residuo_api';
import volumetria_api from '../../../api/volumetria_api';

//Helpers
import { showMessage, showQuestion } from '../../../helpers/message';
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';
import { transformValueFloattoFormated } from '../../../helpers/formats';

//Components
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';
import mascaras from '../../../helpers/mascaras';
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Estado inicial do residuoVolumetria
function initialStateResiduoVolumetria() {
    return {
        tipoResiduo: {},
        volumetria: {},
        volumeMaximoPequenoGerador: "0,00",
    }
}

export default function ResiduoVolumetria({ permissao }) {
    //Estado que faz o controle do modal de cadastro/Edição do residuoVolumetria
    const [openModal, setOpenModal] = useState(false);

    //Estado que faz o controle dos valores dos campos do formulario do residuoVolumetria
    const [residuoVolumetria, setResiduoVolumetria] = useState(initialStateResiduoVolumetria);

    //Estado que guarda a lista de residuosVolumetrias
    const [residuosVolumetrias, setResiduosVolumetrias] = useState([]);

    //Estado que guarda a lista de residuos para fazer o vinculo
    const [residuos, setResiduos] = useState({});

    //Estado que guarda as volumetrias para fazer o vinculo do residuo com a volumetria
    const [volumetrias, setVolumetrias] = useState({});

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos erros nos campos do formulario de residuo volumetria
    const [errors, setErrors] = useState({});

    //Campos obrigatorios do formulario
    const campos = [objCampo({ name: "tipoResiduo", required: true }), objCampo({ name: "volumetria", required: true })]

    //Carrega os residuosVolumetrias e as opções dos selects assim que a tela é iniciada
    useEffect(() => {
        loadRelacaoResiduoVolumetria();
        loadResiduos();
        loadVolumetrias();
    }, [])

    //Faz a troca do estado de exibição do modal
    const toggleModal = () => {
        if (openModal) {
            setResiduoVolumetria(initialStateResiduoVolumetria);
            setErrors({});
        }
        setOpenModal(!openModal);
    }

    //Carrega a lista de residuosVolumetrias
    const loadRelacaoResiduoVolumetria = () => {
        setLoading(true);
        relacaoResiduoVolumetria_api.GetList().then(response => {
            response.data = response.data.map(value => {
                value.volumeMaxPequenoGerador = transformValueFloattoFormated(value.volumeMaxPequenoGerador, 2);
                return value;
            })
            setResiduosVolumetrias(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Carrega as opções de residuos
    const loadResiduos = () => {
        setLoading(true);
        residuo_api.GetList(32).then(response => {
            const _residuos = [];
            response.data.map(residuo => {
                _residuos.push({ label: residuo.descricao, value: residuo.id });
            })
            setResiduos(_residuos);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Carrega as opções de volumetrias   
    const loadVolumetrias = () => {
        volumetria_api.GetList(32).then(response => {
            const _volumetrias = [];
            response.data.map(volumetria => {
                _volumetrias.push({ label: volumetria.tbVolumetria_Descricao, value: volumetria.id });
            })
            setVolumetrias(_volumetrias);
        })
    }

    //Adiciona/Edita uma nova relacao de residuo/volumetria
    const addNovaRelacao = () => {
        const erros = validarCampos(residuoVolumetria, campos);
        if (erros[1].length > 0) {
            setErrors(erros[0]);
            return;
        }
        setLoading(true);
        const _relacaoVolumetria = {
            residuos_ID: residuoVolumetria.tipoResiduo.value,
            volumetria_ID: residuoVolumetria.volumetria.value,
            volumeMaxPequenoGerador: parseFloat(residuoVolumetria.volumeMaximoPequenoGerador.replace(',', '.'))
        }
        if (residuoVolumetria.id) {
            _relacaoVolumetria.id = residuoVolumetria.id;
            relacaoResiduoVolumetria_api.Put(_relacaoVolumetria).then(response => {
                setResiduoVolumetria(initialStateResiduoVolumetria);
                loadRelacaoResiduoVolumetria();
                showMessage("Sucesso", "Relação atualizada com sucesso", "success");
                toggleModal();
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            relacaoResiduoVolumetria_api.Post(_relacaoVolumetria).then(response => {
                setResiduoVolumetria(initialStateResiduoVolumetria);
                loadRelacaoResiduoVolumetria();
                showMessage("Sucesso", "Relação criada com sucesso", "success");
                toggleModal();
            }).catch(e => showMessage("Aviso", e.message, "error", null))
                .finally(f => setLoading(false));
        }
    }

    //OnChange para os campos do formulario de residuo volumetria
    const onChangeRelacaoResiduoVolumetria = (e, select) => {
        if (select && select.name) {
            const _residuoVolumetria = {
                ...residuoVolumetria,
                [select.name]: e
            }
            const campo = campos.filter(c => c.name === select.name);
            const erros = validarCampos(_residuoVolumetria, campo);
            if (erros[1].length == 0) {
                const _errors = { ...errors };
                delete _errors[select.name];
                setErrors({ ..._errors });
            } else {
                setErrors({ ...errors, ...erros[0] })
            }
            setResiduoVolumetria({
                ...residuoVolumetria,
                [select.name]: e
            })
        } else {
            const { name, value } = e.target;
            setResiduoVolumetria({
                ...residuoVolumetria,
                [name]: value
            })
        }
    }

    //Função realizada ao clicar no botão de editar da tabela
    const editarRelacao = (item) => {
        const _relacaoResiduoVolumetria = {
            id: item.id,
            tipoResiduo: {
                label: item.residuo,
                value: item.residuos_ID
            },
            volumetria: {
                label: item.volumetria,
                value: item.volumetria_ID
            },
            volumeMaximoPequenoGerador: item.volumeMaxPequenoGerador
        }
        setResiduoVolumetria(_relacaoResiduoVolumetria);
        toggleModal();
    }

    //Função que remove uma relação da tabela
    const removerRelacaoConfirmation = (confirmation, item) => {
        if (confirmation) {
            setLoading(true);
            relacaoResiduoVolumetria_api.Delete(item.id).then(response => {
                loadRelacaoResiduoVolumetria();
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => {
                setLoading(false);
            })
        }
    }

    //Função executada ao clicar no botão de remover da tabela
    const removerRelacao = (item) => {
        showQuestion("Aviso",
            `Tem certeza que deseja remover esse registro? essa ação não poderá ser desfeita `,
            "info", (confirmation) => removerRelacaoConfirmation(confirmation, item));
    }
    //Ações que serão exibidas na tabela
    const actions = [];
    if (permissao === "Editar") {
        actions.push(actionsTable.editar(editarRelacao));
        actions.push(actionsTable.remover(removerRelacao));
    }

    //Cabeçalhos da tabela
    const headers = [
        { value: "Residuo", objectValue: "residuo", align: "left" },
        { value: "Volumetria", objectValue: "volumetria", align: "left" },
        { value: "Volume Máximo Pequeno Gerador", objectValue: "volumeMaxPequenoGerador", align: "right" },
    ]
    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={toggleModal}>
                <ModalCustomized isOpen={openModal} toggle={toggleModal} title={residuoVolumetria.id ? <><FontAwesomeIcon icon={faEdit} /> Editar relação resíduo volumetria</> : "Nova relação resíduo volumetria"} btnAction={residuoVolumetria.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"} btnActionColor={residuoVolumetria.id ? "warning text-light" : "success"} onClickBtnAction={addNovaRelacao} btnClose>
                    <Row className='mb-4'>
                        <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="6">
                            <TextField invalid={errors.tipoResiduo ? true : false} label={"* Tipos de resíduos"} type={"select"} searchable name={"tipoResiduo"} value={residuoVolumetria.tipoResiduo} onChange={onChangeRelacaoResiduoVolumetria} options={residuos} />
                            <PrintValidate errors={errors} field={"tipoResiduo"} />
                        </Col>
                        <Col md="12" lg="6">
                            <TextField invalid={errors.volumetria ? true : false} label={"* Volumetrias"} type={"select"} searchable name={"volumetria"} value={residuoVolumetria.volumetria} onChange={onChangeRelacaoResiduoVolumetria} options={volumetrias} />
                            <PrintValidate errors={errors} field={"volumetria"} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="12">
                            <TextField mask={mascaras.floatMask} invalid={errors.volumeMaximoPequenoGerador ? true : false} label={"Volume Máximo para Pequenos Geradores"} name={"volumeMaximoPequenoGerador"} value={residuoVolumetria.volumeMaximoPequenoGerador} onChange={onChangeRelacaoResiduoVolumetria} />
                            <PrintValidate errors={errors} field={"volumeMaximoPequenoGerador"} />
                        </Col>
                    </Row>
                </ModalCustomized>
                <div className="mt-4">
                    <TabelaListagem
                        actions={actions}
                        title={"Listagem Resíduo - Volumetria"}
                        items={residuosVolumetrias}
                        options={{ print: false, search: true, pagination: true }}
                        headers={headers}
                    />
                </div>
            </MainCard>
        </>
    )
}